import React from "react";
import { LivechatSubjectType } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { Appointment } from "@scrile/api-provider/dist/projects/webvideo/AppointmentProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/webvideo/UserPublicDataProvider";
import useProduceConsumeController from "pages/PageAppointmentChat/components/hooks/useProduceConsumeController";
import AppointmentStreamView from "../AppointmentStreamView";

interface Props {
  produceUser: UserPublicData;
  livechatSubject: Subject<LivechatSubjectType>;
  appointment?: Appointment;
  disableAttachments?: boolean;
}

function ProduceController({ produceUser, livechatSubject, appointment }: Props) {
  const {
    me,
    userList,
    threadId,
    loading,
    users,
    token,
    produceMediaConstraints,
    onCloseStream,
    onChangeConstraints,
    audioInputs,
    videoInputs,
    isProducerFinishedStream,
    onProducerFinishedStream,
  } = useProduceConsumeController(livechatSubject, true);

  return (
    <AppointmentStreamView
      me={me}
      users={users}
      produceUser={produceUser}
      threadId={threadId}
      loading={loading}
      userList={userList}
      streamStartedDate={appointment?.startTime ?? ""}
      streamEndedDate={appointment?.endTime ?? ""}
      token={token}
      managedConstraints={produceMediaConstraints}
      audioInputs={audioInputs}
      videoInputs={videoInputs}
      onCloseStream={onCloseStream}
      onChangeConstraints={onChangeConstraints}
      isProducerFinishedStream={isProducerFinishedStream}
      onProduceFinishedStream={onProducerFinishedStream}
    />
  );
}

export default ProduceController;
